export default {
      id: "shop-usage",
      viewBox: "80 175 430 430",
      url: __webpack_public_path__ + "assets/icons/icon-sprite.svg#shop-usage",
      toString: function () {
        return this.url;
      }
    }